import React, { useState, useEffect } from 'react';
import ReactDOM from "react-dom";
import {
    ToastWrapper,
} from "./styles";
import ToastItem from "./ToastItem";

export const ToastContainer = (props) => {
    return (
        <ToastWrapper id='toast_wrapper'>
            {props.children}
        </ToastWrapper>
    );
};

export const ToastList = (props) => {
    const currentToast  = props.toast;

    let [list, setList] = useState([])
    let temp = [...list]

    useEffect(() => {
        temp.push({
            id: currentToast.id,
            type: currentToast.type,
            msg: currentToast.msg,
        })
        setList(temp)
    }, [currentToast.id])

    return (
        <>
            {list.map((each, index) => {
                return (
                    <ToastItem
                        key={index}
                        toast={{
                            type: each.type,
                            msg: each.msg,
                        }}
                    />
                )
            })}
        </>
    );
};

class Toast {
    success(msg) {
        ReactDOM.render(
            <ToastList
                toast={{
                    type: "success",
                    msg: msg,
                    id: Date.now()
                }}
            />,
            document.getElementById("toast_wrapper")
        );
    }
    error(msg) {
        ReactDOM.render(
            <ToastList
                toast={{
                    type: "error",
                    msg: msg,
                    id: Date.now()
                }}
            />,
            document.getElementById("toast_wrapper")
        );
    }
    warning(msg) {
        ReactDOM.render(
            <ToastList
                toast={{
                    type: "warning",
                    msg: msg,
                    id: Date.now()
                }}
            />,
            document.getElementById("toast_wrapper")
        );
    }
    info(msg) {
        ReactDOM.render(
            <ToastList
                toast={{
                    type: "info",
                    msg: msg,
                    id: Date.now()
                }}
            />,
            document.getElementById("toast_wrapper")
        );
    }
}

export default new Toast();